import { parseISO } from 'date-fns';
import {
  ExpressionValidator,
  Model,
  Question,
  SurveyValidator
} from 'survey-core';

import { DatePickerTypes } from '../components/DatePicker/DatePickerTypes';

const RETRO_NOT_AFTER_EFFECTIVE_EXPRESSION =
  'isDateOnOrBefore({BusinessInformation_100_RetroactiveDate_WORLD_EN}, {BusinessInformation_100_EffectiveDate_WORLD_EN})';

/**
 * Restrict the Retroactive Date to dates on or before the requested
 * effective date: caps the picker's calendar via maxDate and adds an
 * expression validator to block typed dates past the cap
 * @param  {Model} model
 */
export default function setMaxDateForRetroactiveDate(model: Model): void {
  const retroactiveDateQuestion = model.getQuestionByName(
    'BusinessInformation_100_RetroactiveDate_WORLD_EN'
  ) as Question & DatePickerTypes;
  if (!retroactiveDateQuestion) return;
  const effectiveDate =
    model.data['BusinessInformation_100_EffectiveDate_WORLD_EN'];
  if (!effectiveDate) return;
  const maxDate =
    effectiveDate instanceof Date
      ? effectiveDate
      : parseISO(String(effectiveDate));
  if (isNaN(maxDate.getTime())) return;
  retroactiveDateQuestion.maxDate = maxDate;

  const hasValidator = retroactiveDateQuestion.validators.some(
    (validator: SurveyValidator) =>
      validator instanceof ExpressionValidator &&
      validator.expression === RETRO_NOT_AFTER_EFFECTIVE_EXPRESSION
  );
  if (!hasValidator) {
    const validator = new ExpressionValidator(
      RETRO_NOT_AFTER_EFFECTIVE_EXPRESSION
    );
    validator.text =
      'The Retroactive Date cannot be after the requested effective date.';
    retroactiveDateQuestion.validators.push(validator);
  }
}
